export const pickLocalized = (value, language = "en") => {
  if (value && typeof value === "object") return value[language] || value.en || value.hi || "";
  return value || "";
};
